import { Button, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useState } from 'react';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import * as React from 'react';
import { ListSubheader } from '@mui/material';
import ContentTab from './ContentTab';

import { useParams } from 'react-router-dom';
import axios from 'axios';
import {
  useFetchThisCourseIdQuery,
  useFetchThisSessionAssignmentQuery,
  useFetchThisSessionresourceQuery
} from 'redux/reducers/user/dashboard/tms-course';
import { BsFilePdf } from 'react-icons/bs';
import { BiVideo } from 'react-icons/bi';

function CourseEnrolled() {
  const { id } = useParams();
  const { data } = useFetchThisCourseIdQuery(id);

  const [isHover, setIsHover] = React.useState<any>();

  const [secondID, setIsSecondID] = React.useState<any>();

  const [videosrc, setVideoSrc] = React.useState<string>('');
  const [pdfsrc, setPdfSrc] = React.useState<string>('');

  const [sessionID, setSessionId] = React.useState<number>(0);
  const [sessionName, setSessionName] = React.useState<string>('');

  const [resourceType, setResourcetype] = React.useState('video');
  const { data: DataResource, isLoading: DataLoading } = useFetchThisSessionresourceQuery(
    sessionID,
    resourceType
  );
  const { data: DataAssignment, isLoading: AssignmentLoading } =
    useFetchThisSessionAssignmentQuery(sessionID);

  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }: any) {
    setNumPages(numPages);
  }
  React.useEffect(() => {
    if (data) {
      setSessionId(parseInt(data?.[0]?.course_topic_id));
      setSessionName(data?.[0]?.title);
      setIsHover(data?.[0]?.course_topic_id);
    }
  }, [data]);
  React.useEffect(() => {
    if (DataResource) {
      setIsSecondID(DataResource?.results?.[0]?.course_topic_resource_id);
    }
  }, [DataResource]);
  React.useEffect(() => {
    if (DataResource && resourceType == 'video') {
      setVideoSrc(DataResource?.results?.[0]?.file);
    }
  }, [DataResource]);
  React.useEffect(() => {
    if (DataResource && resourceType == 'pdf') {
      const url = DataResource?.results?.[0]?.file as string;
      loadURL(url).then((res) => setPdfSrc(res));
    }
  }, [DataResource]);

  const OpenPDF = (link: string) => {
    const element = document.createElement('a');
    element.setAttribute('href', link);
    element.setAttribute('target', '_blank');
    document.body.appendChild(element);
    element.click();
    element.remove();
  };
  const loadURL = (url: string): Promise<string> =>
    new Promise((resolve) => {
      (async () => {
        const res = await axios.get(url, { responseType: 'blob' });
        const data = await res.data;
        const blob = new Blob([data], { type: 'text/pdf' });
        const url2 = window.URL.createObjectURL(blob) as string;

        resolve(url2 as string);
      })();
    });

  return (
    <>
      <Box>
        <Grid container>
          <Grid
            item
            xs={12}
            sm={12}
            md={2}
            lg={2}
            xl={2}
            sx={{
              paddingX: 'auto'
            }}
          >
            <Box>
              <Box
                sx={{
                  height: `calc(100% - 300px)`
                }}
              >
                <List
                  subheader={
                    <ListSubheader component="div" id="nested-list-subheader">
                      Module contents
                    </ListSubheader>
                  }
                >
                  <Divider />
                </List>
                {data?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={`${item?.course_topic_id == isHover ? 'active' : 'inactive'}`}
                      style={{
                        padding: '10px',
                        backgroundColor:
                          item?.course_topic_id == isHover ? 'rgb(225 219 219)' : 'white'
                      }}
                      onClick={(e) => {
                        setIsHover(item?.course_topic_id);

                        setSessionId(parseInt(item?.course_topic_id));
                        setSessionName(item?.title);
                      }}
                    >
                      <h5
                        style={{
                          textAlign: 'left',
                          marginLeft: '10px',
                          cursor: 'pointer'
                        }}
                      >
                        {item?.title}
                      </h5>
                    </div>
                  );
                })}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8} xl={8} px={4}>
            <Box
              sx={{
                direction: 'column',
                alignItems: 'start',
                justifyContent: 'start',
                textAlign: 'start'
              }}
            >
              <Typography variant="h5" marginY={1} gutterBottom component="div">
                Computer Usage and Report Writing Skills
              </Typography>
            </Box>
            <Box
              sx={{
                direction: 'column',
                alignItems: 'start',
                justifyContent: 'start',
                textAlign: 'start',
                height: `100%`
              }}
            >
              {/* <ReactPlayer
                url={videosrc}
                className="react-player"
                width="inherit"
                controls
                onReady={() => console.log('callback')}
                onStart={() => console.log('callback')}
                onPause={() => console.log('callback')}
                onError={() => console.log('callback')}
                onEnded={() => console.log('callback')}
              /> */}
              {/* ) : (
                <div className="main">
                  <Document file={pdfsrc} onLoadSuccess={onDocumentLoadSuccess}>
                    {Array.from(new Array(numPages), (el, index) => (
                      <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                    ))}
                  </Document>
                </div>
              )} */}
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={2}
            lg={2}
            xl={2}
            sx={{
              backgroundColor: 'white'
            }}
            marginX="auto"
          >
            <Box>
              <Box
                sx={{
                  height: `calc(100% - 300px)`
                }}
              >
                <div
                  style={{
                    justifyContent: 'space-around',
                    margin: '10px 0'
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setResourcetype('video');
                    }}
                    sx={{ ml: 4, mr: 2 }}
                  >
                    Video
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setResourcetype('pdf');
                    }}
                    sx={{ mr: 2 }}
                  >
                    PDF
                  </Button>
                </div>

                <Divider />
                {resourceType == 'pdf'
                  ? DataResource?.results?.map((item: any, index: number) => {
                      return (
                        <div
                          key={index}
                          className={`${
                            item?.course_topic_resource_id == secondID ? 'active' : 'inactive'
                          }`}
                          style={{
                            padding: '10px',
                            backgroundColor:
                              item?.course_topic_resource_id == secondID
                                ? 'rgb(225 219 219)'
                                : 'white'
                          }}
                          onClick={(e) => {
                            setIsSecondID(item?.course_topic_resource_id);

                            OpenPDF(item?.file);
                          }}
                        >
                          <div
                            style={{
                              textAlign: 'left',
                              marginLeft: '10px',
                              cursor: 'pointer',
                              display: 'flex'
                            }}
                          >
                            <BsFilePdf />
                            <h5 style={{ margin: '3px 0 0 8px' }}> {item?.name}</h5>
                          </div>
                        </div>
                      );
                    })
                  : DataResource?.results?.map((item: any, index: number) => {
                      return (
                        <div
                          key={index}
                          className={`${
                            item?.course_topic_resource_id == secondID ? 'active' : 'inactive'
                          }`}
                          style={{
                            padding: '10px',
                            backgroundColor:
                              item?.course_topic_resource_id == secondID
                                ? 'rgb(225 219 219)'
                                : 'white'
                          }}
                          onClick={(e) => {
                            setIsSecondID(item?.course_topic_resource_id);
                            setVideoSrc(item?.file);
                          }}
                        >
                          <div
                            style={{
                              textAlign: 'left',
                              marginLeft: '10px',
                              cursor: 'pointer',
                              display: 'flex'
                            }}
                          >
                            <BiVideo />
                            <h5 style={{ margin: '3px 0 0 8px' }}> {item?.name}</h5>
                          </div>
                        </div>
                      );
                    })}
              </Box>
            </Box>
          </Grid>
        </Grid>
        <br />
        <br />
        <ContentTab
          moduleID={id}
          sessionID={sessionID}
          sessionName={sessionName}
          Assignments={DataAssignment?.data}
        />
      </Box>
    </>
  );
}

export default CourseEnrolled;
